export const DRAFT = {
  value: "DRAFT",
};

export const FINAL = {
  value: "FINAL",
};

export default [DRAFT, FINAL];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/enums/invoiceSteps.js